import React from "react";
import { Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import Icon from "../../../controls/Icon";
import { completeStep } from "../actions";
import { useTranslation } from "react-i18next";
export function Overlay(props) {
    const { url, id, closeOverlay, desc, isCompleted } = props;
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const onCompleteStep = () => {
        dispatch(completeStep(id));
        closeOverlay();
    };
    return (React.createElement("div", { className: "onboarding-overlay-content" },
        React.createElement("p", null, desc),
        React.createElement("iframe", { ...{
                src: url,
                sandbox: "allow-scripts allow-same-origin allow-presentation allow-forms allow-popups allow-popups-to-escape-sandbox",
                width: "100%",
                height: "335",
                referrerPolicy: "strict-origin-when-cross-origin",
                allow: "encrypted-media; web-share; fullscreen",
                title: "YouTube video player",
                style: { border: 0 },
                allowFullScreen: true,
            } }),
        React.createElement("p", { className: "youtube-privacy-notice" }, t("Playing this video will store cookies on your device")),
        React.createElement("div", { className: "onboarding-overlay-button-container" },
            React.createElement(Button, { className: "onboarding-overlay-button", onClick: onCompleteStep },
                React.createElement(Icon, { className: "onboarding-overlay-button-icon", name: "completed" }),
                isCompleted ? t("Completed") : t("Mark as complete")))));
}
